export enum HeatingOptions {
    UNKNOWN = 0,
    HAS_ANY = 1
}
